import React, { useState, useRef, useEffect } from "react";
import TableIG from "./tableIG";
import { useSelector, useDispatch } from "react-redux";
import { API } from "aws-amplify";
import Loading from "./loading";
import IconAtomsClose from "../Resources/svg/Icons/IconAtomsClose";

const ModalGeneratePdfIG = ({ open, onCloseModalPdf, cleanTablePdfIG }) => {
  const items = useSelector((state) => state.cotizador.valuesPdfIG);
  const activeBtn = useSelector((state) => state.cotizador.btnPdfIG);
  const dispatch = useDispatch();
  const [linkPdf, setLinkPdf] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const elem = useRef(null);

  const onHandlerPdf = async () => {
    setisLoading(true);
    const rowData = items.filter((item) => item.active);
    const response = await API.get(
      "api-rentas",
      "/generate-pdf/" + rowData[0].idQuote
    );

    if (response.status) {
      setLinkPdf(response.data);
    } else {
      console.log(response.message);
    }

    setisLoading(false);
  };

  useEffect(() => {
    if (linkPdf) {
      elem.current.click();
    }
  }, [linkPdf]);

  return (
    <div className={`md-g-wapper  ${open ? "md-g-open" : ""}`}>
      <div className="md-g-wapper__container">
        <div
          className="md-g-wapper__container__button-close"
          onClick={onCloseModalPdf}
        >
          <IconAtomsClose />
        </div>
        <TableIG items={items} />
        <div className="table__btns">
          <a
            style={{ display: "none" }}
            target="_blank"
            rel="noopener noreferrer"
            href={linkPdf}
            ref={elem}
          />
          <button
            className="btnew is-secondary is-medium"
            onClick={() => dispatch(cleanTablePdfIG())}
            disabled={items.length === 0 ? true : false}
          >
            Limpiar Tabla
          </button>
          <button
            className="btnew is-medium"
            onClick={() => onHandlerPdf()}
            disabled={items.length === 0 || !activeBtn ? true : false}
          >
            Descargar PDF
          </button>
        </div>
      </div>
      {isLoading && <Loading  />}
    </div>
  );
};
export default ModalGeneratePdfIG;
